"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mergeArrayValues(key, checked, original) {
    var vals = original || [];
    var index = vals.indexOf(key);
    if (checked) {
        vals.push(key);
    }
    else if (index > -1) {
        vals.splice(index, 1);
    }
    return vals.filter(function (value, index, self) { return self.indexOf(value) === index; });
}
exports.mergeArrayValues = mergeArrayValues;
//# sourceMappingURL=array.js.map